import nanoScroller from '@global/vendors/jquery.nanoscroller.min';
import Vue from 'vue';
import AlertDialog from '@global/helpers/alertDialog';
import messageBox from '@global/helpers/messageBox';
import modal from 'bootstrap/js/dist/modal';
import validate from '@global/vendors/jquery.validate.min';
import Collapse from 'bootstrap/js/dist/collapse';
import globalText from '@global/helpers/globalTxt';
import store from '@global/components/store/index';
import NewImage from '@global/components/global/image';
import $ from 'jquery';
import { mapState, mapGetters, mapActions } from 'vuex';
import { fireSearchListEvent } from '@global/gtm/shopList/shopListView';
import fireSearchEvent from '@global/gtm/search';
import GlobalCtrl from './globalCtrl';

const { globalTxt } = globalText;

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

global.$ = global.jQuery = require('jquery'); // fix can't use JQ in inline script

GlobalCtrl();

if ($('#app-mini-cart').length > 0) {
  window.appNotificationCart = new Vue({
    el: '#app-mini-cart',
    store,
    components: {
      globalTxt,
      NewImage,
    },
    data() {
      return {
        cartContentHeight: '',
        hasProduct: 0,
        GLOBALTXT: window.GLOBALTXT,
      };
    },
    computed: {
      ...mapState('cartModule', ['shoppingData']),
      ...mapState('miniCartModule', [
        'totalCount',
        'generalCount',
        'refrigerationCount',
        'freezingCount',
        'temperaturesData',
        'dataIsLoad',
        'count',
        'generalMarketProducts',
        'refrigerationMarketProducts',
        'freezingMarketProducts',
        'hotSearch',
        'hotLoad',
      ]),
      ...mapGetters('miniCartModule', ['isOnlyOneTemp']),
    },
    watch: {
      hotLoad(value) {
        if (value && window.location.pathname.includes('search')) {
          fireSearchListEvent(this.hotSearch);
        }
      },
    },
    created() {
      this.getCartInfo();
      this.getHotSearch();
    },
    methods: {
      ...mapActions('miniCartModule', ['getCartInfo', 'getHotSearch']),
      goSearch(item) {
        window.location.href = `/search?Keyword=${item}`;
        fireSearchEvent({
          isHotSearch: true,
          keyword: item,
        });
      },
      spread() {
        $('.hot-input-block').addClass('open');
        $('.hot-cancel').css('display', 'inline-block');
      },
    },
  });
}

// fix when mutiple inputs with same name always validate the first item.
$.validator.prototype.checkForm = function () {
  // overriden in a specific page
  this.prepareForm();
  for (let i = 0, elements = (this.currentElements = this.elements()); elements[i]; i++) {
    if (
      this.findByName(elements[i].name).length !== undefined &&
      this.findByName(elements[i].name).length > 1
    ) {
      for (let cnt = 0; cnt < this.findByName(elements[i].name).length; cnt++) {
        this.check(this.findByName(elements[i].name)[cnt]);
      }
    } else {
      this.check(elements[i]);
    }
  }
  return this.valid();
};

// 電子報
const mailValidate = {
  errorClass: 'error',
  errorElement: 'div',
  rules: {
    newsletter: 'required',
  },
  messages: {},
  errorPlacement(error, element) {
    element.parent().append(error);
  },
  submitHandler(form) {
    const $btn = $(form).find('.btn-submit');
    const $input = $(form).find('.input-newsletter');
    $btn.addClass('disabled');
    $.ajax({
      type: 'POST',
      url: '/api/v1/Subscribe/Apply',
      dataType: 'json',
      data: { Email: $input.val() },
      xhrFields: {
        withCredentials: false,
      },
      error() {
        console.log('error');
      },
      success(res) {
        AlertDialog.alert(res.Message, () => {
          $btn.removeClass('disabled');
        });
      },
    });
  },
};
$('#form-newsletter-signup').validate(mailValidate);
$('#form-newsletter-signup-mobile').validate(mailValidate);

// 全域方法前後端使用
window.AlertDialog = AlertDialog;
window.Vue = Vue;
window.messageBox = messageBox;

$('.open-sidebar').click(function (e) {
  e.preventDefault();
  const $el = $(this);
  const target = $el.data('sidebar');
  $(target).addClass('active');
});

$('header').on('click', '.close-sidebar', function (event) {
  event.preventDefault();
  const $el = $(this);
  const target = $el.data('sidebar');
  $(target).removeClass('active');
  $('.mini-cart').show();
  $('.btn-close-burger').addClass('hide');
});

function goToSearch(inputVal) {
  if (inputVal === '') {
    AlertDialog.alert('請輸入關鍵字');
  } else {
    window.location.href = `/search?Keyword=${inputVal}`;
    fireSearchEvent({
      isHotSearch: false,
      keyword: inputVal,
    });
  }
}

$('.form-global-search').on('submit', function (event) {
  event.preventDefault();
  goToSearch($(this).find('input').val());
});

$('.search-btn').click(function (event) {
  event.preventDefault();
  goToSearch($(this).parents('form').find('input').val());
});

$('.btn-global-search').click(function (e) {
  e.preventDefault();
  $('.show-search, .show-search-m').toggleClass('active');
  $(this).parent().find('.show-search-input').get(0).focus();
  $('.show-search-input').focus();
  if (window.matchMedia('(max-width: 768px)').matches) {
    $('.search-mask').toggleClass('active');
  }
});

$('.btn-global-search-close').click((e) => {
  e.preventDefault();
  $('.show-search, .show-search-m').removeClass('active');
  $('.search-mask').removeClass('active');
});

$('body').append('<div class="search-mask"></div>');

$('.btn-show-list').click(function (e) {
  e.preventDefault();

  if ($(this).parents('.cate-sub-list')) {
    $(this).parents('.cate-sub-list').addClass('tmp-hide');
  }
  $(this).parent().find('>ol').addClass('show');
});

$('.btn-burger').click((e) => {
  e.preventDefault();
  $('.mini-cart').hide();
  $('.btn-close-burger').removeClass('hide');
});

$('header').append(
  '<a class="close-sidebar btn-close-burger hide" href="#" data-sidebar="#burger-menu"><i class="icon-remove-x"></i></a>',
);

$('.cate-sub-list li').on('click', function (e) {
  $(this).children().removeClass('no-effect').addClass('effect');
  $(this).siblings().children().removeClass('effect').addClass('no-effect');
  if ($(this).hasClass('cate-back-li')) {
    e.stopPropagation();
    $(this).parents().find('.no-effect').removeClass('no-effect');
    $(this).parents().find('.effect').removeClass('effect');
    $(this).parent().removeClass('show');
    $(this).parents('.cate-sub-list').removeClass('tmp-hide');
  }
});
